import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useState } from "react";
import { formatImageName, formatNumber, handleError } from "../../utils/functions";
import { Link, useNavigate } from "react-router-dom";
import ProductCard from "./ProductCard";
import Rating from "./Rating";
import { useTranslation } from "react-i18next";
import axiosInstance from "../../config/axios.config";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import ReviewModal from "../ReviewModal";

function ShopDetail({ data }) {
  const { t } = useTranslation();
  const [reviewModal, setReviewModal] = useState(false);
  const { token } = useSelector((state) => state.auth);
  const navigate = useNavigate();

  const handleInitiateChat = async () => {
    try {
      if (!token) {
        toast.error("Please Login to initiate chat");
        return;
      }
      const { data: res } = await axiosInstance.post("/user/chat/create", {
        shopId: data?.shop._id,
      });
      if (!res.error) {
        navigate(`/dashboard/chat?chatId=${res.data}`);
        toast.success(res.message);
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      handleError(error);
    }
  };

  const handleReviewSubmit = async (data) => {
    try {
      const { data: res } = await axiosInstance.post(`/user/review`, {
        ...data,
        reviewFor: reviewModal,
        onModel: "Shop",
      });
      if (!res.error) {
        toast.success(res.message);
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      handleError(error);
    } finally {
      setReviewModal(false);
    }
  };

  return (
    <div>
      <section className="vendor-two-details py-80">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="sellerDetialBanner">
                <img
                  src={
                    data?.shop?.banner ? formatImageName(data?.shop?.banner) : "/assets/images/logo/dummy.png"
                  }
                  className=""
                  alt="Banner"
                />
              </div>
            </div>
            <div className="col-md-4 mt-20">
              <div className="d-flex flex-column gap-12 px-lg-0 px-3 py-lg-0 py-4">
                <div className="customGreyDiv rounded-8 p-24">
                  <div className="row align-items-center justify-content-between">
                    <div className="col-md-12 w-100 d-flex align-items-center">
                      <span className="w-80 h-80 flex-center rounded-8 flex-shrink-0 geryDiv">
                        <img
                          src={
                            data?.shop?.logo ? formatImageName(data?.shop?.logo) : "/assets/images/cover.png"
                          }
                          className="w-80 h-80 cover rounded-8"
                          alt="Shop Logo"
                        />
                      </span>
                      &nbsp; &nbsp;
                      <div className="">
                        {data && data.shop && <h6 className="fw-semibold mb-2">{data?.shop?.shopName}</h6>}
                        <div className="flex-align gap-6">
                          <Rating initialRating={data?.shop?.rating} readonly />
                          <span className="text-md mt-2 fw-medium">{data?.shop?.rating || 0}</span>
                          <span className="text-md mt-2 fw-medium">
                            ({formatNumber(data?.shop?.ratingCount || 0)})
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr className="my-30" />
                  <div className="col-12">
                    <h6 className="fw-semibold text-xl mb-2">{t("aboutShop")}</h6>
                    <p className="text-sm mt-10">
                      {data?.shop?.about}
                    </p>
                    <div className="row">
                      <div className="col-sm-6">
                        {token && (
                          <button 
                            className="text-uppercase group border px-16 py-8 rounded mt-20 text-white text-sm bg-main-two-600 text-white border-main-two-600 transition-2 flex-center gap-8 w-100" 
                            onClick={() => setReviewModal(data?.shop._id)}
                          >
                            {t("reviews")} <i className="text-white ph ph-star" />
                          </button>
                        )}
                      </div>
                      <div className="col-md-6">
                        <button
                          type="button"
                          className="text-uppercase group border px-16 py-8 rounded mt-20 text-white text-sm bg-main-two-600 text-white border-main-two-600 transition-2 flex-center gap-8 w-100"
                          onClick={handleInitiateChat}
                        >
                          {t("chatNow")}
                          <span className="text-xl d-flex text-main-two-600 group-item-white transition-2">
                            {" "}
                            <i className="text-white ph ph-storefront" />
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                  <hr className="my-30" />
                  <div className="col-12">
                    <h6 className="fw-semibold text-xl mb-20">{t("shopBusinessInfo")}</h6>
                    <div className="location-box bg-white flex-align gap-8 rounded-pill mb-20">
                      <div className="line-height-1">
                        <span className="text-gray-600 text-xs">{t("shopEmail")}</span>
                        <div className="line-height-1">
                          <h6 className="mb-0 text-16">
                            <Icon icon="uiw:mail" /> {data?.shop?.shopEmail}
                          </h6>
                        </div>
                      </div>
                    </div>
                    <div className="location-box bg-white flex-align gap-8 rounded-pill mb-20">
                      <div className="line-height-1">
                        <span className="text-gray-600 text-xs">{t("shopNumber")}</span>
                        <div className="line-height-1">
                          <h6 className="mb-0 text-16">
                            <Icon icon="fluent:call-add-16-filled" /> {data?.shop?.shopPhoneNumber}
                          </h6>
                        </div>
                      </div>
                    </div>
                    <div className="location-box bg-white flex-align gap-8 rounded-pill mb-20">
                      <div className="line-height-1">
                        <span className="text-gray-600 text-xs">{t("shopLocation")}</span>
                        <div className="line-height-1">
                          <h6 className="mb-0 text-16">
                            <i className="ph ph-map-pin" /> {t("pakistan")}
                          </h6>
                        </div>
                      </div>
                    </div>
                    <div className="location-box bg-white flex-align gap-8 rounded-pill mb-20">
                      <div className="line-height-1">
                        <span className="text-gray-600 text-xs">{t("shopAddress")}</span>
                        <div className="line-height-1">
                          <h6 className="mb-0 text-16">
                            <i className="ph ph-map-pin" /> {data?.shop?.shopPhoneNumber}
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr className="my-30" />
                  <div className="col-12">
                    <p className="mb-10 d-flex justify-content-between px-16 py-12 text-black hover-text-white border border-neutral-500 w-100 rounded-4 hover-bg-main-600 hover-border-main-600">
                      <div>
                        <Icon className="text-xl" icon="mingcute:star-fill" />
                        &nbsp; {t("shopRating")}
                      </div>
                      {data?.shop?.rating || 0}
                    </p>
                    <p className="mb-10 d-flex justify-content-between px-16 py-12 text-black hover-text-white border border-neutral-500 w-100 rounded-4 hover-bg-main-600 hover-border-main-600">
                      <div>
                        <Icon className="text-xl" icon="ant-design:product-filled" />
                        &nbsp; {t("totalProducts")}
                      </div>
                      {data?.products?.length || 0}
                    </p>
                    <p className="mb-10 d-flex justify-content-between px-16 py-12 text-black hover-text-white border border-neutral-500 w-100 rounded-4 hover-bg-main-600 hover-border-main-600">
                      <div>
                        <Icon className="text-xl" icon="material-symbols:order-approve" />
                        &nbsp; {t("successfulOrders")}
                      </div>
                      {data?.orders || 0}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-8 mt-20">
              <div className="section-heading mb-10 flex-between flex-wrap">
                <h5 className="mb-0">{t("products")}</h5>
                <Link
                  to="/products"
                  class="btn btn-main-two fw-medium d-inline-flex align-items-center rounded-pill gap-8"
                >
                  {t("seeAllProducts")}
                  <span class="icon text-xl d-flex">
                    <i class="ph ph-arrow-right"></i>
                  </span>
                </Link>
              </div>
              <div className="row g-12">
                {data?.products?.map((item) => (
                  <ProductCard item={item} className="col-lg-4 col-sm-4 col-6" key={item._id} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
      <ReviewModal visible={!!reviewModal} setVisible={setReviewModal} onSubmit={handleReviewSubmit} />
    </div>
  );
}

export default ShopDetail;
